
import RewardsFaqItem from '~/components/rewards-page/rewards-faq-item'
export default {
  components: { RewardsFaqItem },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
